import { createTheme } from "@material-ui/core/styles";

const themeObj = {
  palette: {
    primary: {
      main: "#AC552B",
    },
    secondary: {
      main: "#ffffff",
      contrastText: "#c76a3c",
    },
  },
  typography: {
    fontFamily: "Gotham Medium",
    color: "#5B5D62",
  },
  overrides: {
    MuiButton: {
      root: {
        fontFamily: "Gotham Bold",
      },
      contained: {
        height: "48px",
        minWidth: "256px",
        "@media (min-width:768px)": {
          height: "64px",
        },
      },
      containedSecondary: {
        backgroundColor: "#ffffff",
        color: "#c76a3c",
        "&:hover": {
          backgroundColor: "#ffffff",
        },
      },
      sizeSmall: {
        padding: "7px 10px ",
        height: "48px",
        minWidth: "164px",
        "@media (min-width:768px)": {
          fontSize: "14px",
        },
      },
    },
    MuiMenuItem: {
      root: {
        fontFamily: "Averta Bold",
      },
    },
    MuiSwitch: {
      root: {
        padding: "0",
        borderRadius: "18px",
        width: "53px",
        height: "24px",
      },
      thumb: {
        width: "18px",
        height: "18px",
        boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.15)",
      },
      switchBase: {
        padding: "3px",
        "&:hover": {
          backgroundColor: "transparent",
        },
        "&&&&$checked": {
          transform: "translateX(calc(100% + 5px))",
          color: "white",
        },
        "&&&&$checked + $track": {
          opacity: "1",
          backgroundColor: "#AC552B",
        },
        "&&&&$checked + &&&&$disabled + $track": {
          opacity: ".2",
        },
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: "none",
        background: "white",
      },
    },
    MuiInputBase: {
      input: {
        zIndex: "10",
      },
    },
    MuiList: {
      root: {
        background: "#0077d6",
        color: "#e0fc01",
      },
    },
    MuiFilledInput: {
      root: {
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
        borderBottomLeftRadius: "4px",
        borderBottomRightRadius: "4px",
        backgroundColor: "white",
      },

      underline: {
        "&:before": {
          display: "none !important",
        },
      },
    },

    MuiFormLabel: {
      root: {
        marginBottom: "15px",
        color: "#000000",
      },
    },
    MuiFormControl: {
      root: {
        marginBottom: ".8rem",
      },
    },
    MuiRadio: {
      root: {
        color: "black",
      },
    },
    PrivateRadioButtonIcon: {
      root: {
        color: "black",
      },
    },
  },
};

const theme = createTheme(themeObj);
export { theme, themeObj };
